export default __webpack_public_path__ + "static/7-5e44fd3ed302faa3ba6aaec7a1291e81.webp";